import React, { useEffect, useRef, useState } from 'react';
import { loadFromLocalStorage, saveToLocalStorage } from '../elements/api/CookieManagement';
import CenterBox from '../elements/centerBox';
import useInterval from '../Hooks/useInterval';
import * as api from '../elements/api/api';


function Player(props) {

    const audioRef = useRef();
    const videoRef = useRef();
    const overlayRef = useRef();
    const [currentPosition, setCurrentPosition] = useState(0);
    const [currentPositionAutosetToBePerform,setCurrentPositionAutosetToBePerform] = useState(false);
    const [intervalIdjumpToPositionIfClipIsLoaded, setintervalIdjumpToPositionIfClipIsLoaded] = useState(null);

    
    const clearWaitForMedium = useInterval(() => waitUntilMediaIsAvailable(), 100)
    const [waitForMedium, setWaitForMedium] = useState(0);
    //0: mediaNotInitialized
    //1: media initialized and wait for media
    //2: media initializied and media ready
    let mediaInitialized = false;

    const closePlayer = () => {
        document.title = "YT-Downloader";

        if(intervalIdjumpToPositionIfClipIsLoaded!=null){
            clearInterval(intervalIdjumpToPositionIfClipIsLoaded)
        }

        storeCurrentPosition();
        clearWaitForMedium();
        props.setShowPlayer(false);

    }

    const waitUntilMediaIsAvailable = () => {
        if (waitForMedium == 2)
            return;
        const id = props.source.id;
        if (props.rowsRef.current.find((row) => row.id == id).status == api.FINISHED) {
            setWaitForMedium(2);
        }
        else {
            setWaitForMedium(1);
        }

    }


    const setCurrentPositionInPlayer = () => {
        if (props.source.type == "audio") {
            if (audioRef) {
                audioRef.current.currentTime = currentPosition;
            }
        }
        else if (props.source.type == "video") {
            if (videoRef) {
                videoRef.current.currentTime = currentPosition;
            }
        }
    };



    useEffect(() => {
        let current_position=0;
        console.log(props.source.categories)
        //console.log(waitForMedium)
        if (waitForMedium < 2 || props.source.categories.some((c) => c.toLowerCase() === "music")) {
            return;
        }
        let mediaBookmarks = loadFromLocalStorage("mediaBookmarks");
        // console.log(props.source.id)
        // console.log(Object.keys(mediaBookmarks))
        // console.log(Object.keys(mediaBookmarks).includes(props.source.id))
        if (mediaBookmarks != null && Object.keys(mediaBookmarks).includes(props.source.id)) {

            current_position = mediaBookmarks[props.source.id];
            setCurrentPosition(current_position);
            setCurrentPositionAutosetToBePerform(true)
        }
        else {
            setCurrentPosition(0)
        }




    }, [waitForMedium]);

    useEffect(() => {
        if(!currentPositionAutosetToBePerform){
            return;
        }
        const jumpToPositionIfClipIsLoaded = () =>
        {
            const ref = props.source.type == "audio" ? audioRef : videoRef;
            if(ref.current.currentTime > 1 & currentPosition>=1 & currentPosition>=ref.current.currentTime){
                setCurrentPositionInPlayer()
            }
            else if(ref.current.currentTime >= currentPosition){
                clearInterval(intervalId)
            }
        };
        const intervalId = setInterval(jumpToPositionIfClipIsLoaded, 500)
        setintervalIdjumpToPositionIfClipIsLoaded(intervalId)
        setCurrentPositionAutosetToBePerform(false)
    },[currentPositionAutosetToBePerform]);



    const storeCurrentPosition = () => {
        if (waitForMedium != 2)
            return;
        let currentPosition = 0;
        let duration = 0;
        if (props.source.type == "audio") {
            currentPosition = audioRef.current.currentTime;
            duration = audioRef.current.duration;
        }
        else if (props.source.type == "video") {
            currentPosition = videoRef.current.currentTime;
            duration = videoRef.current.duration;
        }
        let mediaBookmarks = loadFromLocalStorage("mediaBookmarks");
        if (mediaBookmarks == null) {
            mediaBookmarks = new Object();
        }
        if (currentPosition > duration - 1)
            return;
        mediaBookmarks[props.source.id] = currentPosition;
        saveToLocalStorage("mediaBookmarks", mediaBookmarks);
        //console.log("stored")
    }

    //removes the current position of the media from the local storage if an entry with its id exists in the mediaBookmarks
    const removeCurrentPosition = () => {
        let mediaBookmarks = loadFromLocalStorage("mediaBookmarks");
        if (mediaBookmarks != null) {
            delete mediaBookmarks[props.source.id];
            saveToLocalStorage("mediaBookmarks", mediaBookmarks);
        }
    }
    const minimizePlayer = () => {
        // overlayRef.current.style="display:none";
        props.minimizePlayer();
    }

    useEffect(() => {
        setWaitForMedium(0)
    }, [props.source.stream_url])

    useEffect(() => {
        if (waitForMedium < 2) return;

        const playMedia = async () => {
            try {
                if (props.source.type === "audio" && audioRef?.current) {
                    audioRef.current.load();
                    await audioRef.current.play();

                } else if (props.source.type === "video" && videoRef?.current) {
                    videoRef.current.load();
                    await videoRef.current.play();

                }

            } catch (error) {
                console.warn("Autoplay blockiert oder fehlgeschlagen:", error);
                alert("Autoplay wurde blockiert. Bitte tippe auf Play.");
            }
        };

        playMedia();
    }, [waitForMedium]);




    const callbackAfterMediumEnds = () => {
        //console.log(props);
        //setWaitForMedium(0);
        removeCurrentPosition();
        props.callback();
    };

    return (

        <div class="overlay">
            <div class="kasten" onClick={e => e.preventDefault()}>
                <button class="minimize-btn" onClick={minimizePlayer}>-</button>
                <button class="close-btn" onClick={closePlayer}>×</button>

                <h4>{props.source.title}</h4>
                {
                    (waitForMedium == 1 ? (
                        <CenterBox text="Waiting until media is available" />)
                        :

                        props.source.type == "audio" ? (
                            <audio onPause={() => storeCurrentPosition()} ref={audioRef} autoPlay onEnded={callbackAfterMediumEnds} controls>
                                <source src={props.source.stream_url}></source>
                            </audio>) : (
                            <video onPause={() => storeCurrentPosition()} ref={videoRef} autoPlay onEnded={callbackAfterMediumEnds} controls>
                                <source src={props.source.stream_url}></source>
                            </video>))




                }


                {
                    currentPosition >= 1 && <p><button onClick={() => setCurrentPositionInPlayer()} className='basic-button'>Jump to marked position</button></p>
                }


            </div>
        </div>
    );

}

export default Player;